import React from 'react';
import {
  POSP_CHP,
  POSP_DASH,
  POSP_DETAILS,
  POSP_EXAM,
  POSP_PRODUCT,
  POSP_STATUS,
  POSP_TRAINING,
} from '.';

export const authRoutes = [
  {
    path: POSP_STATUS,
    label: 'Status',
    isNavLink: false,
    component: React.lazy(() => import('../../pages/Status/Status')),
    children: [],
    role: ['pos'],
    profileStatus: [0, 2, 3],
  },
  {
    path: POSP_EXAM,
    label: 'Exam',
    isNavLink: true,
    component: React.lazy(() => import('../../pages/Exam/Exam')),
    children: [],
    role: ['pos'],
    profileStatus: [4, 5],
  },
  {
    path: POSP_DETAILS,
    label: 'Application',
    isNavLink: true,
    component: React.lazy(() => import('../../pages/Profile/Profile')),
    children: [],
    role: ['pos'],
    profileStatus: [0, 2],
  },
  {
    path: POSP_TRAINING,
    label: 'Training',
    isNavLink: true,
    component: React.lazy(() => import('../../pages/Training/Overview')),
    children: [],
    role: ['pos'],
    profileStatus: [4, 5],
  },
  {
    path: `${POSP_TRAINING}/${POSP_CHP}`,
    label: '',
    isNavLink: false,
    component: React.lazy(() => import('../../pages/Training/Start')),
    children: [
      { path: ':cId', label: '', isNavLink: false, component: () => <p></p> },
    ],
    profileStatus: [4, 5],
  },

  {
    path: `${POSP_DASH}`,
    label: 'My Dashboard',
    isNavLink: true,
    component: React.lazy(() => import('../../pages/Dashboard/Dashboard')),
    children: [],
    role: ['pos'],
    profileStatus: [6],
  },

  {
    path: `${POSP_PRODUCT}`,
    label: 'Products',
    isNavLink: true,
    component: React.lazy(() => import('../../pages/Insurance/Products')),
    children: [
      {
        path: 'car-insurance',
        label: 'Car Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Motor/Car/Car')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Motor/Car/Result')
            ),
          },
        ],
      },

      {
        path: 'two-wheeler-insurance',
        label: 'Two Wheeler Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Motor/2Wheeler/TwoWheeler')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Motor/2Wheeler/Result')
            ),
          },
        ],
      },
      {
        path: 'health-insurance/individual',
        label: 'Health Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Health/Individual')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Health/Individual/Quotes')
            ),
          },
        ],
      },
      {
        path: 'health-insurance/family',
        label: 'Health Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Health/Group/')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Health/Group/Quotes')
            ),
          },
        ],
      },
      {
        path: 'health-insurance/multi-individual',
        label: 'Health Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Health/MultiIndividual')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Health/MultiIndividual/Quotes')
            ),
          },
        ],
      },
      {
        path: 'pcv-insurance',
        label: 'PCV Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Motor/PCV/pcv')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Motor/PCV/Result')
            ),
          },
        ],
      },
      {
        path: 'gcv-insurance',
        label: 'GCV Insurance',
        isNavLink: true,
        component: React.lazy(() =>
          import('../../pages/Insurance/Motor/GCV/gcv')
        ),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Motor/GCV/Result')
            ),
          },
        ],
      },
      {
        path: 'travel-insurance',
        label: 'Travel Insurance',
        isNavLink: true,
        component: React.lazy(() => import('../../pages/Insurance/Travel')),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/Travel/Quotes')
            ),
          },
        ],
      },
      {
        path: 'term-life-insurance',
        label: 'Term Life Insurance',
        isNavLink: true,
        component: React.lazy(() => import('../../pages/Insurance/TermLife')),
        children: [
          {
            path: 'quotes',
            label: '',
            isNavLink: false,
            component: React.lazy(() =>
              import('../../pages/Insurance/TermLife/Quotes')
            ),
          },
        ],
      },
    ],
    role: ['pos'],
    profileStatus: [6],
  },
  {
    path: 'not-found',
    isNavLink: false,
    component: React.lazy(() => import('../../pages/NotFound/404')),
    children: [],
    profileStatus: [0, 1, 2, 3, 4, 5, 6, 7],
  },
  {
    path: 'leads',
    isNavLink: false,
    component: React.lazy(() => import('../../pages/Leads/Leads')),
    children: [],
    profileStatus: [6],
  },
  // {
  //   path: '*',
  //   isNavLink: false,
  //   component: React.lazy(() => import('../../pages/NotFound/404')),
  //   children: [],
  //   profileStatus: ['*'],
  // },
];

export const noAuthRoutes = [
  {
    path: '/profile',
    isNavLink: false,
    component: React.lazy(() => import('../../pages/Profile/Profile')),
    children: [],
  },
  {
    path: '/',
    component: React.lazy(() => import('../../pages/Home/Home')),
    label: '',
    isNavLink: true,
  },
  {
    path: '/under-construction',
    component: React.lazy(
      () => import('../../pages/PageUnderConstruction/PageUnderConstruction') // Import the construction page
    ),
    label: '',
    isNavLink: true,
  },
  {
    path: '/home-2',
    component: React.lazy(() => import('../../pages/Home2/Home2')),
    label: '',
    isNavLink: true,
  },
  {
    path: '/about',
    component: React.lazy(() => import('../../pages/About/About')),
    label: '',
    isNavLink: true,
  },
  {
    path: '/contact',
    component: React.lazy(() => import('../../pages/ContactUs/ContactUs')),
    label: '',
    isNavLink: true,
  },
  {
    path: '/management-team',
    isNavLink: false,
    component: React.lazy(() =>
      import('../../pages/ManagementTeam/ManagementTeam')
    ),
    children: [],
  },
  {
    path: '/efficient-team',
    isNavLink: false,
    component: React.lazy(() =>
      import('../../pages/EfficientTeam/EfficientTeam')
    ),
    children: [],
  },
  {
    path: 'posp/register',
    component: React.lazy(() => import('../../pages/Register/Register')),
    // component: React.lazy(()=>import('../../pages/Register/Register')),
    label: 'Become POS',
    isNavLink: true,
  },
  {
    path: 'posp/login',
    component: React.lazy(() => import('../../pages/Register/Register')),
    label: 'Login',
    isNavLink: true,
  },
  {
    path: '*',
    component: React.lazy(() => import('../../pages/NotFound/404')),
    label: '',
    isNavLink: false,
  },
];
